import { useEffect, useRef } from "react";
import { useGame } from "../../app/GameProvider.js";
import { STAT_HELP, topicFromOverlay } from "./statHelp.js";

export function StatHelpDialog() {
  const { state, dispatch } = useGame();
  const dialogRef = useRef<HTMLDivElement>(null);
  const topic = topicFromOverlay(state.overlay);

  useEffect(() => {
    if (!topic) return;
    dialogRef.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") dispatch({ type: "CLOSE_OVERLAY" });
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [topic, dispatch]);

  if (!topic) return null;
  const copy = STAT_HELP[topic];
  const close = () => dispatch({ type: "CLOSE_OVERLAY" });

  return (
    <div className="overlay" role="presentation" onClick={close}>
      <div
        ref={dialogRef}
        className="dialog phase-tutorial-dialog"
        role="dialog"
        aria-modal="true"
        aria-label={copy.title}
        tabIndex={-1}
        onClick={(event) => event.stopPropagation()}
      >
        <header>
          <img src="/secretary.png" alt="" />
          <h2>{copy.title}</h2>
        </header>
        {copy.body.map((line) => (
          <p key={line}>{line}</p>
        ))}
        <button type="button" className="btn btn-primary" onClick={close}>
          わかった
        </button>
      </div>
    </div>
  );
}
